exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide{display: none;}\n\n\n@media (max-width: 991px) {\n    ::ng-deep .wizard > .steps > ul > li{\n        width: 33.33% !important;\n    }\n\n    ::ng-deep .wizard > .steps a{\n        margin: 2px !important;\n        font-size: 12px;\n    }\n\n    ::ng-deep .wizard ul{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    ::ng-deep .wizard > .steps > ul > li a{\n        height: 90%;\n    }\n\n} \n\n@media (max-width: 776px) {\n.ibox-content{\n    padding: 15px 10px 20px 10px;\n}\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/wizard/wizard.component.css
// module id = ../../../../../src/app/wizard/wizard.component.css
// module chunks = main